import { withStyles } from '@mui/styles';

import { FirmWithdrawalWallets } from './firmWithdrawalWallets';
import { muiStyles } from './styles';

export default withStyles(muiStyles)(FirmWithdrawalWallets);